import { useLocation, useNavigate } from 'react-router-dom';
import DraggableModal from '../../../../common/ant-components/DraggableModal';
import React, { useEffect } from 'react';
import { AntButton } from '../../../../common/ant-components/AntButton';
import { useNavigationHistory } from '../../../../common/navigation-history';
import { returnLinks } from '../../../../common/navigation-history/data';
import { BACK_ROUTES_PATH } from './data';
import { useTransactionContext } from '@/context/TransactionContext';

export const ConfirmModal = (props) => {
  const { yesNo = false, setYesNo } = props;
  const navigate = useNavigate();
  const history = useNavigationHistory();
  const location = useLocation();
  const pathname = location?.pathname;

  const exclude = [
    '/codewindow',
    '/sales/return/code/window',
    '/purchase/return/code/window',
    '/transaction/sales/create/',
    '/transaction/sales/edit/',
    '/ledger-details/reports/',
    '/stock/detail/report/',
    '/stock/ledger/report/',
    '/ledger/reports/',
    '/stock-summary/reports/',
  ];

  const isExcluded = exclude?.some((path) =>
    location?.pathname?.startsWith(path),
  );

  const isRedirectPath = BACK_ROUTES_PATH?.find(
    (item) => item?.route === pathname || pathname.startsWith(item.route),
  )?.route_to_redirect;

  const state = location?.state || null;

  const { ledgerDetails, stockDetails, setLedgerDetails } =
    useTransactionContext();

  const stateData = ledgerDetails
    ? ledgerDetails
    : stockDetails?.code
      ? stockDetails
      : state;

  const target = isExcluded
    ? null
    : [...history]
        .reverse()
        .find(
          (path, index) =>
            index === 1 &&
            returnLinks?.some((prefix) => path.startsWith(prefix)),
        );

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.code === 'ArrowRight') {
        e.preventDefault();
        requestAnimationFrame(() => {
          props?.noRef?.current?.focus();
        });
      }
      if (e.code === 'ArrowLeft') {
        e.preventDefault();
        requestAnimationFrame(() => {
          props?.yesRef?.current?.focus();
        });
      }
      // if (e.code === 'Escape') {
      //   e.preventDefault();
      //   target
      //     ? navigate(target, {
      //         state: {
      //           ...stateData,
      //         },
      //       })
      //     : isRedirectPath
      //       ? navigate(isRedirectPath, {
      //           state: {
      //             ...stateData,
      //           },
      //         })
      //       : navigate(-1);
      // }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  useEffect(() => {
    if (location?.pathname?.includes('/stock/ledger/report/')) {
      setLedgerDetails(null);
    }
  }, [location?.pathname?.includes('/stock/ledger/report/')]);

  return (
    <DraggableModal
      open={yesNo}
      onCancel={() => setYesNo(false)}
      width={400}
      // title={'Do you want to save changes?'}
      title={'Are you sure you want to exit?'}
      footer={
        <div className="tw-flex tw-justify-end tw-gap-x-3">
          <div>
            <AntButton
              ref={props.yesRef}
              onClick={() => {
                target
                  ? navigate(target, {
                      state: {
                        ...stateData,
                      },
                    })
                  : isRedirectPath
                    ? navigate(isRedirectPath, {
                        state: {
                          ...stateData,
                        },
                      })
                    : navigate(-1);
              }}
            >
              Yes
            </AntButton>
          </div>
          <div>
            <AntButton
              color="red"
              ref={props.noRef}
              onClick={() => {
                setYesNo(false);
              }}
            >
              No
            </AntButton>
          </div>
        </div>
      }
      children={undefined}
      setOpen={function (e) {
        throw new Error('Function not implemented.');
      }}
    />
  );
};
